(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oda-moon-purchase"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('.oda-moon-purchase__thumb');
    if (!thumb) return;
    var section = thumb.closest('.oda-moon-purchase');
    var main = section && section.querySelector('.oda-moon-purchase__main-image');
    if (main) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.dataset.imageUrl; }
    section.querySelectorAll('.oda-moon-purchase__thumb').forEach(function(item) { item.style.borderColor = ''; item.removeAttribute('aria-current'); });
    thumb.style.borderColor = '#3483fa'; thumb.setAttribute('aria-current', 'true');
  });
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form.matches('.oda-moon-purchase__form')) return;
    var before = null;
    fetch('/cart.js', { credentials:'same-origin' }).then(function(r) { return r.json(); }).then(function(cart) {
      before = cart.item_count;
      var tries = 0;
      var timer = setInterval(function() {
        if (++tries > 40) { clearInterval(timer); return; }
        fetch('/cart.js', { credentials:'same-origin' }).then(function(r) { return r.json(); }).then(function(current) {
          if (before !== null && current.item_count > before) { clearInterval(timer); window.location.assign('/cart'); }
        }).catch(function() {});
      }, 250);
    }).catch(function() {});
  }, true);

  } catch(e) { console.error(e); }
})();
})();
